import { useContext } from "react";
import { ApiContext } from "./ApiProvider";
import { CbSDKApi } from "@akqa_denmark/cb-sdk/build-es5/create-api";

/**
 * Convenience React Hook instead of having developers use the longhand with multiple imports:
 * ```
 * import React, {useContext} from 'react';
 * import {ApiContext} from '../carlsberg-headless/ApiProvider';
 * import {ApiService, CbApi} from '../carlsberg-headless/ApiService';
 *
 * const MyComponent: React.FC = () => {
 *     const api = useContext<CbApi>(ApiContext);
 *     ...
 * }
 *
 * use the shorthand:
 * import React from 'react';
 * import {useApi} from '../carlsberg-headless/useApi';
 *
 * const MyComponent: React.FC = () => {
 *     // no need to strongly type it in your own components
 *     const api = useApi();
 *     ...
 * }
 * ```
 */
const useApi = (): CbSDKApi => {
  return useContext<CbSDKApi>(ApiContext);
};

export { useApi };
